@if (!products.length) {
    @if (canAdd && canAddProduct && config[type].url) {
        <div class="columns is-aligned-center is-mobile">
            <div class="column is-narrow">
                <a [href]="config[type].url" class="link is-pulled-right">
                    {{ config[type].homeTitle }}
                </a>
            </div>
        </div>
    }
}
@if (products?.length > 0 && showProducts) {
    <div role="list" class="box ml-0 mr-0 rows">
        <div class="is-flex is-spaced-between">
            <p class="title is-level-5">
                {{ config[type].title }}
            </p>
            @if (canAdd && canAddProduct && config[type].url) {
                <a [href]="config[type].url" role="link" aria-label="Ajouter un accessoire" class="link">Ajouter</a>
            }
        </div>
        <div data-testid="separator" class="divider is-marginless has-background-grey"></div>

        @for (product of products; track product; let last = $last) {
            <div role="listitem" class="row is-12">
                <checkout-crosssell-item
                    (removeProductEvent)="removeProduct($event)"
                    (addProductEvent)="addProduct($event)"
                    [product]="product"
                    [totalProductsQty]="totalProductsQty"
                />
            </div>
            @if (!last) {
                <div data-testid="separator" class="divider is-marginless has-background-grey-fade"></div>
            }
        }
    </div>
}
